import { render } from "./ModalTransactionPin.vue?vue&type=template&id=ce14e952"
import script from "./ModalTransactionPin.vue?vue&type=script&lang=js"
export * from "./ModalTransactionPin.vue?vue&type=script&lang=js"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__